import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { ViewState } from '#components/Root/viewModel'
import type { Transitioner } from '#components/TransitionProvider'
import type { Nodes } from '#models/Nodes'

import * as mobx from 'mobx'
import PT from 'prop-types'

export type Props = {
  state: ViewState
}

export type ViewModel = {
  showButtons: boolean
  showContinue: boolean
  showBack: boolean
  showCancel: boolean

  handleNext: () => void
}

type Context = {
  models: { nodes: Nodes }
  transitioner: Transitioner
}

const mkViewModel = (
  params: Params,
  { state }: Props,
  { transitioner }: Context,
): ViewModel => {
  const vm = mobx.observable({
    get showButtons() {
      return vm.showContinue || vm.showBack || vm.showCancel || vm.showClose
    },
    get showContinue() {
      return state.currentNode && state.currentNode.nextNode
    },
    get showBack() {
      return state.currentNode && state.currentNode.allowBack
    },
    get showCancel() {
      return (
        state.currentNode &&
        state.currentNode.allowCancel &&
        state.currentNode.nextNode
      )
    },
    get showClose() {
      return (
        state.currentNode &&
        state.currentNode.allowCancel &&
        !state.currentNode.nextNode
      )
    },

    handleNext: mobx.action(() => {
      const nextNodeId =
        state.currentNode &&
        state.currentNode.nextNode &&
        state.currentNode.nextNode.id
      if (nextNodeId) transitioner.goForward(nextNodeId)
    }),
  })

  return vm
}

mkViewModel.contextTypes = {
  transitioner: PT.object.isRequired,
}

export default mkViewModel
